// extracted by mini-css-extract-plugin
export default {"container":"ServiceType_container__MEZAu","content":"ServiceType_content__KY0WZ"};